var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemoCta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8149 12.973L13.7185 18.7922C13.3722 19.1039 12.8526 19.1039 12.5408 18.7575C12.2291 18.4112 12.2291 17.8916 12.5755 17.5798L17.1824 13.1808H5.40538C4.92044 13.1808 4.57406 12.8344 4.57406 12.3495C4.57406 11.8992 4.92044 11.5182 5.40538 11.5182H17.1824L12.5755 7.15375C12.2291 6.84201 12.2291 6.2878 12.5408 5.97605C12.8526 5.62967 13.4068 5.62967 13.7185 5.94141L19.8149 11.7606C19.988 11.9338 20.092 12.1416 20.092 12.3495C20.092 12.5919 19.988 12.7998 19.8149 12.973Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoCta);
export default __webpack_public_path__ + "static/media/demoCTA.6d076c4e2b3c55ddc6a33f02d4a61ace.svg";
export { ForwardRef as ReactComponent };